var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-circle-container",style:({ width: _vm.size + 'vw', height: _vm.size + 'vw', opacity: _vm.opacity })},[(_vm.isPresent)?_c('div',{ref:"bgCircle",staticClass:"bg-circle",class:{ blinking: _vm.isBlinking }}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }